import { useState } from "react";
import { Dices } from "lucide-react";
import { Btn } from "./kit";
import { reveal } from "./Reveal";
import { ACC, fmt } from "./util";

const BETS = [10, 100, 1000, 5000, 25000];

// The Sea Casino's slots, with the odds out in the open.
export function Casino({ eco, onSignIn }) {
  const { econ } = eco;
  const [pick, setPick] = useState(null);
  if (!econ) return <Btn className="mt-3 w-full py-2.5" onClick={onSignIn}>Sign in with X to play</Btn>;
  const c = econ.casino, bets = BETS.filter((b) => b >= c.min && b <= c.max), bet = pick ?? bets[0];
  const back = c.mults.reduce((n, m, i) => n + m * c.odds[i], 0) / 10;
  const spin = async () => {
    const r = await eco.act("/casino/spin", { bet });
    if (r) reveal({ kind: "casino", mult: r.mult, uxd: r.won, top: r.mult === Math.max(...c.mults) });
  };
  return (
    <div data-testid="casino">
      <p className="mt-1 text-sm text-x-ink">Slots out on the water. Three of a kind pays your bet back:</p>
      <div className="mt-2 grid grid-cols-3 gap-2">
        {c.mults.map((m, i) => (
          <div key={m} className="hud-well rounded-[10px] px-2 py-1.5 text-center">
            <div className="text-sm font-semibold">{m}×</div>
            <div className="text-[11px] tabular-nums text-x-mute">{c.odds[i] / 10}% of spins</div>
          </div>
        ))}
      </div>
      <p className="mt-2 text-xs text-x-mute">On average a spin pays back {back}% of the bet. Winnings don't count towards the week.</p>
      <div className="mt-3 flex gap-1.5" role="radiogroup" aria-label="Bet">
        {bets.map((b) => (
          <button key={b} type="button" role="radio" aria-checked={b === bet} onClick={() => setPick(b)} style={{ "--acc": ACC.gold }}
            className={`flex-1 rounded-full py-1.5 text-xs font-semibold tabular-nums ${b === bet ? "acc-fill" : "hud-well text-x-mute hover:text-x-ink"}`}>{fmt(b)}</button>
        ))}
      </div>
      <Btn className="mt-2 flex w-full items-center justify-center gap-1.5 py-2.5" disabled={eco.busy || econ.uxd < bet} onClick={spin} data-testid="casino-spin">
        <Dices className="h-4 w-4" />{econ.uxd < bet ? `${fmt(bet - econ.uxd)} UXD short` : `Spin · ${fmt(bet)}`}
      </Btn>
    </div>
  );
}
